import { useTranslation } from 'react-i18next'

import type { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { CommonPaths } from '@utils/path-common'

import { useFundingNav } from '@hooks/useFundingNav'

import { useDepositTracker } from '@analytics/amplitude/deposit'

type DepositModalProps = {
  accountId?: string
  onCloseWidget?: () => void
}

export const DepositModal: BaseModalType<DepositModalProps> = ({
  close,
  accountId,
  onCloseWidget,
}) => {
  const { t } = useTranslation()

  const { navigateToFunding } = useFundingNav()
  const tracker = useDepositTracker()

  const handleClose = () => {
    onCloseWidget?.()
    close()
  }

  const handleClickDeposit = async () => {
    if (!accountId) {
      return
    }
    tracker.start({ entry_point: 'trade_markets_modal', preset_ta_id: accountId })
    await close()
    navigateToFunding(`${CommonPaths.TradersRoomTradingAccounts}/${accountId}/deposit`)
  }

  return (
    <Modal size='md'>
      <Modal.Header>{t('Instruments.Ready to start trading')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('Instruments.Add funds to your account to start trading')}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleClose}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleClickDeposit}>{t('Deposit')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
